import { NgOptimizedImage } from '@angular/common'
import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-image',
  template: `<img [ngSrc]="src()" [alt]="alt()" [width]="widthValue()" [height]="heightValue()" />`,
  styles: `
    :host {
      display: block;
    }
    img {
      object-fit: contain;
      max-width: 100%;
      width: auto;
      height: auto;
      max-height: 30rem;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgOptimizedImage],
})
export class ImageComponent {
  readonly src = input.required<string>()
  readonly alt = input<string>('')
  readonly width = input<string>('')
  readonly height = input<string>('')

  readonly widthValue = computed(() => parseInt(this.width(), 10) || 1080)
  readonly heightValue = computed(() => parseInt(this.height(), 10) || 400)
}
